import { Controller } from "@hotwired/stimulus"

// Copies a value (the wallet address) to the clipboard and says so on the
// button for a moment. Without a clipboard API the button selects nothing
// and the full address is still in the element's title for a long press.
export default class extends Controller {
  static targets = ["button", "label"]
  static values = { text: String, copied: { type: String, default: "Copied" } }

  async copy() {
    try {
      await navigator.clipboard.writeText(this.textValue)
    } catch {
      return
    }
    const label = this.labelTarget
    const original = label.textContent
    label.textContent = this.copiedValue
    this.buttonTarget.setAttribute("aria-pressed", "true")
    clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      label.textContent = original
      this.buttonTarget.removeAttribute("aria-pressed")
    }, 2000)
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
